import React from 'react'
import { Stack,Box } from '@mui/system';
import ChannelCard from './ChannelCard';
import VideoCard from './VideoCard';
function Videos({videos,direction}) {
    //console.log(videos);
    if(!videos?.length) return 'Loading ....'
  return (
    <Stack direction={direction || "row"} flexWrap="wrap" justifyContent="flex-start" alignItems="start" gap={2}>
      {videos.map((item, idx) => (
        <Box key={idx}>
          {item.id.videoId && <VideoCard video={item} /> }
          {item.id.channelId && <ChannelCard channelDetail={item} />}
        </Box>
      ))}
    </Stack>
  )
}

export default Videos

